export enum MatchProfileTableColumns {
  Name = "name",
  ProfileId = "profileId",
  DefaultProfile = "defaultProfile",
  ExternalId = "externalId",
}
